/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * 🔒 Prevent any library (like webpack-dev-server HMR or pace-js)
 * from overriding the native WebSocket constructor.
 * This must be the very first code in this file.
 */
const nativeWebSocket = window.WebSocket;
Object.defineProperty(window, 'WebSocket', {
  configurable: false, // ✅ make it non-overridable
  enumerable: true,
  get: () => nativeWebSocket,
  set: () => {
    console.warn('⚠️ Attempt to override WebSocket ignored');
  },
});

/**
 * 🚫 Disable Zone.js WebSocket patch (must be BEFORE Zone import)
 */
(window as any).__Zone_disable_WebSocket = true;
console.log('__Zone_disable_WebSocket BEFORE zone load:', (window as any).__Zone_disable_WebSocket);

/**
 * 🧩 Optional: Log first WebSocket send to debug handshake payload
 */
const origSend = WebSocket.prototype.send;
let first = true;
WebSocket.prototype.send = function (...args: any[]) {
  if (first) {
    first = false;
    console.log('FIRST WS SEND (monkey):', args[0]);
  }
  return origSend.apply(this, args);
};

/***************************************************************************************************
 * IE / legacy browser polyfills
 */
import 'classlist.js';
import 'web-animations-js';

/***************************************************************************************************
 * Core-js polyfills (for Angular < 16)
 */
import 'core-js/es6/reflect';
import 'core-js/es7/reflect';

/***************************************************************************************************
 * Zone JS — required by Angular
 * KEEP AFTER the disable flag above ⬆️
 */
import 'zone.js'; // Included with Angular CLI

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
import 'core-js/es7/array';
import 'core-js/es7/object';

/***************************************************************************************************
 * SVG polyfill (for older browsers)
 */
if (typeof SVGElement.prototype.contains === 'undefined') {
  SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
}
